import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import {  Badge, } from 'reactstrap';


const statusColors = {
  RECEIVED_SIGNED: { 
    background: 'rgba(100, 199, 124, 0.2)',
    color: '#64C77C',
  },
  SENT_TO_SIGN: { 
    background: 'rgba(255, 193, 7, 0.2)',
    color: '#ECB100',
  },
  NEGOTIATION: {
    background: 'rgba(244, 123, 51, 0.2)',
    color: '#F47B33'
  },
  SENT_TO_FILL: {
    background: 'rgba(255, 193, 7, 0.2)',
    color: '#ECB100'
  }
}

function StatusText({status, className}) {
  const { t } = useTranslation('common');
  const statusText = !status.length ?  'DRAFT' : status;


  return (
    <Badge className={`${className}`} pill style={statusColors[statusText]}>
      {t(`documentStatus.${statusText}`)}
    </Badge>
  )
}

StatusText.propTypes = {
  status: PropTypes.string.isRequired,
  className: PropTypes.string
}

export default StatusText

